import { setItemToLocalStorage, getItemFromLocalStorage } from '@/utils/helper';
import { sessionApi, userApi } from '@/api';
import { TOKEN_NAME_CONSTANT } from '@/utils/constans';
import store from '@/store';
import { storeUserData } from '@/store/commonDuck/credentialDuck';
import { EncryptedSessionDataInterface } from '@/types';

export const checkIsTokenValid = async (isDoctor?: boolean) => {
  try {
    const { data } = isDoctor
      ? await userApi.getUserB2B()
      : await userApi.getUser();
    // set store user data in here
    store.dispatch(storeUserData(data));
    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const checkEncryptedSessionLogin: (
  query: {
    credential?: '';
  },
  isDoctor?: boolean
) => Promise<EncryptedSessionDataInterface> = async (query, isDoctor) => {
  try {
    // eslint-disable-next-line no-throw-literal
    if (!query.credential) throw 'Credential not exsist';
    const { data } = isDoctor
      ? await sessionApi.encryptedSessionB2B({
          credential: query.credential,
        })
      : await sessionApi.encryptedSession({
          credential: query.credential,
        });
    setItemToLocalStorage(
      TOKEN_NAME_CONSTANT.REFRESH_TOKEN,
      data.refresh_token
    );
    setItemToLocalStorage(TOKEN_NAME_CONSTANT.TOKEN, data.token);
    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const checkIfTokenIsExsist = () => {
  const token = getItemFromLocalStorage(TOKEN_NAME_CONSTANT.TOKEN);
  const refreshToken = getItemFromLocalStorage(
    TOKEN_NAME_CONSTANT.REFRESH_TOKEN
  );
  if (token && refreshToken) {
    return true;
  }
  return false;
};

export const checkIfCredentialsIsExsist = () => {
  /**
   * return true if credentials store exsist return false if credentials is not exsist
   */
  const {
    credentials: { userData },
  } = store.getState();
  return Object.keys(userData).length;
};
